import React from 'react';
import './Differentiators.css';
import { useComponentAnalytics } from '../hooks/useAnalytics';

const Differentiators = () => {
  const { trackInteraction } = useComponentAnalytics('Differentiators');

  const differentiators = [
    {
      id: 1,
      icon: '🛡️',
      title: 'Gobernanza como Ventaja Competitiva',
      description: 'La gobernanza de la IA ha dejado de ser una simple característica técnica para convertirse en un diferenciador estratégico en empresas líderes.',
      highlights: [
        'Un marco robusto de gobernanza permite escalar con confianza',
        'Evita riesgos reputacionales, filtraciones de datos y mal uso de recursos',
        'Backoffice con roles configurables a medida, ajustes de límites de uso, fuentes habilitadas, tono y vocabulario'
      ],
      stats: null
    },
    {
      id: 2,
      icon: '⚙️',
      title: 'Eficiencia Operativa Multiplicada',
      description: 'Con documentación consolidada, cada equipo puede ahorrar decenas de horas al mes en búsquedas, consultas cruzadas y tareas redundantes.',
      highlights: [
        'La reutilización del conocimiento y automatización de tareas multiplica la eficiencia',
        'Generación de artefactos, respuestas técnicas y flujos de decisión automatizados',
        'Una operación crece sin multiplicar costos proporcionales'
      ],
      stats: { value: 'Decenas de horas', label: 'ahorradas mensualmente' }
    },
    {
      id: 3,
      icon: '🔒',
      title: 'Mitigación de Riesgos y Cumplimiento',
      description: 'La plataforma garantiza que agentes IA no accedan a fuentes sensibles o reguladas, según rol.',
      highlights: [
        'Control sobre el uso de tokens, el tono, las fuentes y el perfil de usuario',
        'Auditabilidad y trazabilidad del uso de IA',
        'Requisito para compliance y auditorías internas en entornos regulados'
      ],
      stats: null
    },
    {
      id: 4,
      icon: '📈',
      title: 'Escalabilidad con Gobernanza Integrada',
      description: 'En lugar de crecer desordenadamente, tu plataforma escala controlada y segura.',
      highlights: [
        'Nuevos equipos pueden activarse sin exponer todo el conocimiento',
        'Niveles de servicio para clientes: perfiles básicos con acceso reducido',
        'Perfiles premium con mayor profundidad de información'
      ],
      stats: null
    },
    {
      id: 5,
      icon: '💡',
      title: 'Transformación de Datos en Decisiones',
      description: 'Muchas empresas tienen datos no estructurados — la plataforma puede transformar ese reservorio en activos de decisión.',
      highlights: [
        'Transforma datos en respuestas, flujos y sugerencias estratégicas',
        'Evoluciona hacia un módulo que genera productos de información interna',
        'Insights o servicios basados en conocimiento institucional'
      ],
      stats: null
    }
  ];

  const handleDifferentiatorClick = (diffId, diffTitle) => {
    trackInteraction('differentiator_view', 'section', {
      differentiator_id: diffId,
      differentiator_title: diffTitle
    });
  };

  return (
    <section id="diferenciadores" className="differentiators section">
      <div className="container">
        <div className="differentiators-header">
          <h2 className="section-title">Diferenciadores Clave</h2>
          <p className="section-subtitle">
            Lo que hace única a nuestra plataforma y genera valor real para tu organización
          </p>
        </div>

        <div className="differentiators-grid">
          {differentiators.map((diff, index) => (
            <div 
              key={diff.id} 
              className={`differentiator-card fade-in-up ${index % 2 === 0 ? 'card-left' : 'card-right'}`}
              style={{ animationDelay: `${index * 0.15}s` }}
              onClick={() => handleDifferentiatorClick(diff.id, diff.title)}
            >
              <div className="card-number">0{diff.id}</div>
              <div className="card-icon">{diff.icon}</div>
              <h3 className="card-title">{diff.title}</h3>
              <p className="card-description">{diff.description}</p>
              
              <div className="card-highlights">
                {diff.highlights.map((highlight, idx) => (
                  <div key={idx} className="highlight-item">
                    <span className="highlight-dot"></span>
                    <span className="highlight-text">{highlight}</span>
                  </div>
                ))}
              </div>

              {diff.stats && (
                <div className="card-stats">
                  <div className="stat-value">{diff.stats.value}</div>
                  <div className="stat-label">{diff.stats.label}</div>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="differentiators-summary">
          <div className="summary-content">
            <h3>¿Por qué elegir ExpertMind?</h3>
            <div className="summary-points">
              <div className="summary-point">
                <span className="point-icon">✓</span>
                <span>Gobernanza empresarial desde el día uno</span>
              </div>
              <div className="summary-point">
                <span className="point-icon">✓</span>
                <span>Reducción real de costos operacionales</span>
              </div>
              <div className="summary-point">
                <span className="point-icon">✓</span>
                <span>Compliance y auditoría integrada</span>
              </div>
              <div className="summary-point">
                <span className="point-icon">✓</span>
                <span>Escalabilidad sin límites</span>
              </div>
              <div className="summary-point">
                <span className="point-icon">✓</span>
                <span>Transformación de datos en insights accionables</span>
              </div>
            </div>
            <a href="#contacto" className="btn btn-primary btn-large">
              <span>Comienza tu transformación</span>
              <span className="btn-icon">→</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Differentiators;
